
export default {
    API_KEY: process.env.REACT_APP_API_KEY,
    AMBIENTE: process.env.REACT_APP_AMBIENTE,
    API_URL: process.env.REACT_APP_API_URL,
    EA_URL_EVENTO: process.env.REACT_APP_EA_EVENTOS,
} 


// WEBPACK FOOTER //
// ./src/Config.js